const cutCamelCase = (source) =>
  source.replace(/([A-Z])/g, ' $1').toLowerCase();

export default cutCamelCase;
